module.exports = __webpack_public_path__ + "static/media/title_art_utility.a58a5faa.svg";